(() => {
    'use strict';

    angular
        .module('uwAgenda.users')
        .controller('ContactCleanupController', [
            '$uibModalInstance',
            'info',
            'modalResult',
            'IntegratorTypeEnum',
            ContactCleanupControllerFn]);

    function ContactCleanupControllerFn(
        $uibModalInstance,
        info,
        modalResult,
        IntegratorTypeEnum) {
        let viewModel = this;

        viewModel.info = info;
        viewModel.deactivateNonSynced = false;
        viewModel.mergeDoppelgangers = false;
        viewModel.showMergeDoppelgangers = info.integrationType === IntegratorTypeEnum.CareconnectGp.value;

        viewModel.no = () => {
            $uibModalInstance.dismiss();
        };
        
        viewModel.yes = () => {            
            modalResult.deactivateNonSynced = viewModel.deactivateNonSynced;
            modalResult.mergeDoppelgangers = viewModel.mergeDoppelgangers;
            $uibModalInstance.close();
        };
    }
})();
